// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--IXHVp","expert-img":"_61cc05a7c9--expert-img--1-9IP","text":"_61cc05a7c9--text--fKB4o","link":"_61cc05a7c9--link--37F8g"};